import service from "@/utils/service"

//角色列表
export function getRoleList(data) {
  return service({
    url: "/sys/role/view",
    method: "post",
    data: data
  })
}

// 添加按钮
export function createRole(data) {
  return service({
    url: "/sys/role/add",
    method: "post",
    data: data
  })
}

// 编辑按钮
export function updateRole(data) {
  return service({
    url: "/sys/role/edit",
    method: "post",
    data: data
  })
}

// 删除按钮
export function deleteRole(data) {
  return service({
    url: "/sys/role/del",
    method: "post",
    data: data
  })
}

//获取menu, 不需要权限验证
export function getAllMenus() {
  return service({
    url: "/sys/role/allmenus",
    method: "get"
  })
}
//获取当前角色的菜单权限,不需要权限验证
export function getRoleMenu(data) {
  return service({
    url: "/sys/role/rolemenu",
    method: "post",
    data: data
  })
}

//  获取角色拥有角色权限 不需权限验证
export function getRoleRole(data) {
  return service({
    url: "/sys/role/rolerole",
    method: "post",
    data: data
  })
}
//保存菜单权限
export function saveRoleMenuPerms(roleId, rolemenuperms) {
  return service({
    url: "/sys/role/saverolemenuperm",
    method: "post",
    data: { roleId, rolemenuperms }
  })
}
//保存角色权限
export function saveRoleRolePerms(data) {
  return service({
    url: "/sys/role/saveroleroleperm",
    method: "post",
    data: data
  })
}
